module.exports = __webpack_public_path__ + "img/170.8cf60fcf.jpg";